import PropTypes from 'prop-types'
import React from 'react'
import { getInputClasses } from '../../helpers/obtenerClasesInput'
import useError from '../hooks/useError'

// soporta Controlled Component y Uncontrolled Componennte si se le pasa por prop un "defaultValue"
const Select = React.forwardRef((props, ref) => {
  const {
    name,
    value,
    className,
    disabled,
    datos,
    optionMetaDatos,
    optionPorDefecto,
    onChange,
    errores,
    ...rest
  } = props
  const { ShowError, hayError } = useError(errores, name)

  return (
    <>
      <select
        {...rest}
        ref={ref}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        className={getInputClasses(className, { disabled, hayError })}
        disabled={disabled}
        aria-disabled={disabled}
      >
        {optionPorDefecto && (
          <option value={optionPorDefecto.value}>{optionPorDefecto.text}</option>
        )}
        {datos.map((dato) => (
          <option key={dato[optionMetaDatos.value]} value={dato[optionMetaDatos.value]}>
            {dato[optionMetaDatos.text]}
          </option>
        ))}
      </select>
      {<ShowError />}
    </>
  )
})

Select.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  datos: PropTypes.array.isRequired,
  optionMetaDatos: PropTypes.object.isRequired,
  optionPorDefecto: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    text: PropTypes.string.isRequired
  }),
  onChange: PropTypes.func,
  errores: PropTypes.object
}

Select.displayName = 'Select'

export default Select
